// extracted by mini-css-extract-plugin
module.exports = {"myModal":"Header_myModal__RlO2K","mymodalSlideIn":"Header_mymodalSlideIn__6Fe2l","mymodalSlideOut":"Header_mymodalSlideOut__0c31y"};